{
  "table": {
    "title": "Sincronizaciones",
    "description": "Cada ejecución con su resultado. Abre una para ver el detalle por registro.",
    "caption": "Historial de sincronizaciones",
    "filtersLegend": "Filtrar sincronizaciones",
    "resource": "Recurso",
    "status": "Estado",
    "allResources": "Todos los recursos",
    "allStatuses": "Todos los estados",
    "columns": {
      "resource": "Recurso",
      "mode": "Modo",
      "status": "Estado",
      "startedBy": "Lanzada por",
      "startedAt": "Inicio",
      "duration": "Duración",
      "result": "Resultado"
    },
    "openRun": "Ver la sincronización de {resource} del {date}",
    "notStarted": "Sin iniciar",
    "noChanges": "Sin cambios",
    "counters": {
      "created": "{count} creados",
      "updated": "{count} actualizados",
      "needs_review": "{count} para revisión",
      "error": "{count} con error"
    },
    "empty": {
      "title": "Aún no hay sincronizaciones",
      "description": "Cuando sincronices un recurso, aparecerá aquí con su resultado."
    },
    "noResults": {
      "title": "No hay sincronizaciones con estos filtros",
      "description": "Prueba con otro recurso o estado."
    },
    "error": "No pudimos cargar el historial"
  },
  "items": {
    "title": "Detalle por registro",
    "description": "Registros creados, actualizados, omitidos o con error. Corrige los errores en tu sistema y vuelve a sincronizar.",
    "unchangedHint": "{count} registros sin cambios no se listan.",
    "caption": "Registros de la sincronización",
    "filtersLegend": "Filtrar registros",
    "result": "Resultado",
    "recordType": "Tipo",
    "allResults": "Todos los resultados",
    "allRecordTypes": "Todos los tipos",
    "columns": {
      "externalId": "Id externo",
      "recordType": "Tipo",
      "result": "Resultado",
      "entity": "En Fermin",
      "changedFields": "Campos cambiados",
      "message": "Mensaje",
      "warnings": "Advertencias"
    },
    "proposal": "Propuesta: {label}",
    "unexpectedError": "Error inesperado al aplicar el registro.",
    "empty": {
      "title": "Sin registros con cambios",
      "description": "Esta sincronización no creó, actualizó ni omitió ningún registro."
    },
    "noResults": {
      "title": "No hay registros con estos filtros",
      "description": "Prueba con otro resultado o tipo."
    },
    "error": "No pudimos cargar el detalle"
  },
  "export": {
    "button": "Descargar Excel",
    "downloaded": "Descargamos {filename}",
    "failed": "No pudimos descargar el Excel"
  },
  "notReported": {
    "title": "No reportados",
    "description": "Sedes y trabajadores vinculados que la última sincronización completa no informó. Siguen activos en Fermin.",
    "caption": "Vínculos no reportados",
    "columns": {
      "entityType": "Tipo",
      "entity": "En Fermin",
      "externalId": "Id externo",
      "since": "Desde"
    },
    "empty": "Todos los vínculos se informaron en la última sincronización completa.",
    "error": "No pudimos cargar los no reportados",
    "unlink": "Desvincular",
    "unlinkLabel": "Desvincular {label}",
    "dialogTitle": "¿Desvincular {label}?",
    "dialogDescription": "Dejará de actualizarse desde el sistema externo y sus datos pasarán a editarse en Fermin.",
    "unlinked": "{label} ya se edita en Fermin"
  }
}
